import React from 'react';
import {Link} from 'react-router-dom';
import classes from '../courses.module.css';
import IntlMessage from '../../../components/IntlMessage/IntlMessage';

/**
 * Курса с таким слагом нет.
 *
 * Рендерится как обычная ветка JSX уже после всех хуков страницы, а не ранним return:
 * ранний выход изменил бы число вызванных хуков между рендерами, а ErrorBoundary
 * в приложении нет — пользователь получил бы белый экран вместо сообщения.
 */
const CourseNotFound = () => (
    <div className={classes.notFound}>
        <h1 className={classes.notFoundTitle}>
            <IntlMessage id="coursesPage.course.notFound"/>
        </h1>
        <p className={classes.notFoundText}>
            <IntlMessage id="coursesPage.course.notFoundText"/>
        </p>
        <Link to="/courses" className={classes.btnPrimary}>
            <IntlMessage id="coursesPage.course.backToList"/>
        </Link>
    </div>
);

export default CourseNotFound;
